<template>
	<div id="imo1-main">
		<div class="row mb-4">
			<div class="col-sm-12">
				<div class="d-flex align-items-center mb-2">
					<h4 class="m-0 me-4">ADD IMO 1 CONDITION Record</h4>
					<a id="add_imo1_btn" class="btn btn-outline-dark btn-sm" :href="docRoot+'/imo1'">Back to list</a>
				</div>
			</div>
		</div>
		<div class="row mb-4 align-items-center">
			<div class="col-md-2 col-12 text-md-end px-1">
				<label for="add_imo1_tank_no" class="form-label text-uppercase fw-bold m-0 me-3">Tank No <span class="mandatory">*</span></label><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
			</div>
			<div class="col-md-3 col-12">
				<div class="input-group">
					<!-- <input type="text" class="form-control" v-model="imo1ForAdd.tank_no" id="add_imo1_tank_no" placeholder="Enter Tank No" @keyup="tankNoVerified = false"/> -->
					<MaskInput v-model="imo1ForAdd.tank_no" mask="AAAA-######-#" class="form-control" :readonly="tankNoVerified" textmode="uppercase"/>
					<span class="input-group-text" :class="tankNoVerified ? 'bg-success' : 'bg-danger'">
						<i class="ph ph-check text-white" v-if="tankNoVerified"></i>
						<i class="ph ph-x text-white" v-if="!tankNoVerified"></i>
					</span>
				</div>
				<template v-for="error of v$.imo1ForAdd.tank_no.$errors" :key="error.$uid">
					<div class="mandatory mb-1">{{ error.$message }}</div>
				</template>
			</div>
			<div class="col-md-4 col-12 mt-2 mt-md-0" v-if="!tankNoVerified">
				<button type="button" class="btn btn-dark btn-sm" @click="verifyTankNumber()">VERIFY TANK NUMBER</button>
			</div>
			<div class="col-md-6 py-2" v-if="imo1ForAdd.id == 0 && tankNoVerified">
				<label for="">Tank last used: <span v-if="lastThree && lastThree.length > 0">On {{  lastThree.join(", ") }}</span><span v-else>Never</span></label>
			</div>
		</div>
		<template v-if="tankNoVerified">
			<div class="row mb-2 align-items-center g-2 g-md-0">
				<div class="col-md-2 col-6  text-md-end px-1">
					<label for="add_imo1_ref_no" class="form-label text-uppercase fw-bold m-0 me-3">Ref No</label><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
				</div>
				<div class="col-md-3 col-6 ">
					<input type="text" class="form-control" v-model="imo1ForAdd.ref_no" id="add_imo1_ref_no" readonly placeholder="AUTOGENERATED"/>
				</div>
				<div class="col-md-2 col-6  text-md-end px-1">
					<label for="add_imo1_csc" class="form-label text-uppercase fw-bold m-0 me-3">CSC</label><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
				</div>
				<div class="col-md-3 col-6 ">
					<input type="text" class="form-control" v-model="imo1ForAdd.csc" id="add_imo1_csc" placeholder="Enter Csc" />
				</div>
			</div>
			<div class="row mb-2 align-items-center g-2 g-md-0">
				<div class="col-md-2 col-6  text-md-end px-1">
					<label for="add_imo1_company_id" class="form-label text-uppercase fw-bold m-0">Company <span class="mandatory">*</span></label>
				</div>
				<div class="col-md-3 col-6 ">
					<select class="form-select" v-model="imo1ForAdd.company_id" id="add_company_id">
						<optgroup v-if="allCompanyIdList" label="Choose Company">
							<template v-for="companyId in allCompanyIdList" :key="companyId.id">
								<option :value="companyId.id">{{ companyId.name }}</option>
							</template>
						</optgroup>
					</select>
					<template v-for="error of v$.imo1ForAdd.company_id.$errors" :key="error.$uid">
						<div class="mandatory mb-1">{{ error.$message }}</div>
					</template>
				</div>
				<div class="col-md-2 col-6  text-md-end px-1">
					<label for="add_imo1_loaded_at" class="form-label text-uppercase fw-bold m-0 me-3">Loaded At</label
					><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
				</div>
				<div class="col-md-3 col-6 ">
					<input type="text" class="form-control" v-model="imo1ForAdd.loaded_at" id="add_imo1_loaded_at" placeholder="Enter Loaded At" />
				</div>
			</div>
			<div class="row mb-2 align-items-center g-2 g-md-0">
				<div class="col-md-2 col-6  text-md-end px-1">
					<label for="add_imo1_inspection_date" class="form-label text-uppercase fw-bold m-0">Inspection Date</label>
				</div>
				<div class="col-md-3 col-6 ">
					<MaskInput v-model="imo1ForAdd.inspection_date" mask="##-##-####" class="form-control" textmode="uppercase" placeholder="DD-MM-YYYY"/>
					<!-- <input type="date" class="form-control" v-model="imo1ForAdd.inspection_date" id="add_imo1_inspection_date" placeholder="Enter Inspection Date" /> -->
				</div>
				<div class="col-md-2 col-6  text-md-end px-1">
					<label for="add_imo1_tank_type_id" class="form-label text-uppercase fw-bold m-0">Tank Type</label>
				</div>
				<div class="col-md-3 col-6 ">
					<select class="form-select" v-model="imo1ForAdd.tank_type_id" id="add_tank_type_id">
						<optgroup v-if="allTankIdList" label="Choose Tank Type">
							<template v-for="tankId in allTankIdList" :key="tankId.id">
								<option :value="tankId.id">{{ tankId.type }}</option>
							</template>
						</optgroup>
					</select>
				</div>
			</div>
			<div class="row mb-2 align-items-center g-2 g-md-0">
				<!-- <div class="col-2 text-md-end px-1">
					<label for="add_imo1_tank_no" class="form-label text-uppercase fw-bold m-0 me-3">Tank No <span class="mandatory">*</span></label
					><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
				</div>
				<div class="col-3">
					<input type="text" class="form-control" v-model="imo1ForAdd.tank_no" id="add_imo1_tank_no" placeholder="Enter Tank No" />
					<div v-if="v$.imo1ForAdd.tank_no.$error" class="mandatory ms-3">Mandatory</div>
				</div> -->
				<div class="col-md-2 col-6  text-md-end px-1">
					<label for="add_imo1_tcode_id" class="form-label text-uppercase fw-bold m-0">TCode</label>
				</div>
				<div class="col-md-3 col-6 ">
					<select class="form-select" v-model="imo1ForAdd.tcode_id" id="add_tcode_id">
						<optgroup v-if="allTcodeIdList" label="Choose TCode">
							<template v-for="tcodeId in allTcodeIdList" :key="tcodeId.id">
								<option :value="tcodeId.id">{{ tcodeId.name }}</option>
							</template>
						</optgroup>
					</select>
				</div>
			</div>
			<div class="row mb-2 align-items-center g-2 g-md-0">
				<div class="col-md-2 col-6  text-md-end px-1">
					<label for="add_imo1_last_cargo_carried" class="form-label text-uppercase fw-bold m-0 me-3">Last Cargo Carried</label
					><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
				</div>
				<div class="col-md-3 col-6 ">
					<input type="text" class="form-control" v-model="imo1ForAdd.last_cargo_carried" id="add_imo1_last_cargo_carried" placeholder="Enter Last Cargo Carried" />
				</div>
				<div class="col-md-2 col-6  text-md-end px-1">
					<label for="add_imo1_mfgt_date" class="form-label text-uppercase fw-bold m-0">Mfgt Date</label>
				</div>
				<div class="col-md-3 col-6 ">
					<input type="text" class="form-control" v-model="imo1ForAdd.mfgt_date" id="add_imo1_mfgt_date" placeholder="Enter Mfgt Date" />
					<!-- <MonthYearPicker  v-model="imo1ForAdd.mfgt_date" :min="new Date(1990, 1, 1)" :max="new Date()" returnmode="String" class="form-select"/> -->
				</div>
			</div>
			<div class="row mb-2 align-items-center g-2 g-md-0">
				<div class="col-md-2 col-6  text-md-end px-1">
					<label for="add_imo1_empty_clean" class="form-label text-uppercase fw-bold m-0">Empty Clean</label>
				</div>
				<div class="col-md-3 col-6 ">
					<select class="form-select" v-model="imo1ForAdd.empty_clean" id="add_empty_clean">
						<optgroup v-if="allEmptyCleanList" label="Choose Empty Clean">
							<template v-for="emptyClean in allEmptyCleanList" :key="emptyClean.id">
								<option :value="emptyClean.id">{{ emptyClean.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-6  text-md-end px-1">
					<label for="add_imo1_empty_dirty" class="form-label text-uppercase fw-bold m-0">Empty Dirty</label>
				</div>
				<div class="col-md-3 col-6 ">
					<select class="form-select" v-model="imo1ForAdd.empty_dirty" id="add_empty_dirty">
						<optgroup v-if="allEmptyDirtyList" label="Choose Empty Dirty">
							<template v-for="emptyDirty in allEmptyDirtyList" :key="emptyDirty.id">
								<option :value="emptyDirty.id">{{ emptyDirty.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
			</div>
			<div class="row mb-2 align-items-center g-2 g-md-0">
				<div class="col-md-2 col-6  text-md-end px-1">
					<label for="add_imo1_cfs" class="form-label text-uppercase fw-bold m-0">CFS</label>
				</div>
				<div class="col-md-3 col-6 ">
					<select class="form-select" v-model="imo1ForAdd.cfs" id="add_cfs">
						<optgroup v-if="allCfsList" label="Choose Cfs">
							<template v-for="cfs in allCfsList" :key="cfs.id">
								<option :value="cfs.id">{{ cfs.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-6  text-md-end px-1">
					<label for="add_imo1_for_client" class="form-label text-uppercase fw-bold m-0">For</label>
				</div>
				<div class="col-md-3 col-6 ">
					<multiselect v-model="imo1ForAdd.for_client" :options="allForClientList" :custom-label="displayLabelSetting" placeholder="Select one" selectLabel="" deselectLabel=""></multiselect>
				</div>
			</div>
			<div class="row mb-2 align-items-center g-2 g-md-0">
				<div class="col-md-2 col-6  text-md-end px-1">
					<label for="add_imo1_loaded" class="form-label text-uppercase fw-bold m-0">Loaded</label>
				</div>
				<div class="col-md-3 col-6 ">
					<select class="form-select" v-model="imo1ForAdd.loaded" id="add_loaded">
						<optgroup v-if="allLoadedList" label="Choose Loaded">
							<template v-for="loaded in allLoadedList" :key="loaded.id">
								<option :value="loaded.id">{{ loaded.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-6  text-md-end px-1">
					<label for="add_imo1_next_date" class="form-label text-uppercase fw-bold m-0">Next Date</label>
				</div>
				<div class="col-md-3 col-6 ">
					<input type="text" class="form-control" v-model="imo1ForAdd.next_date" id="add_imo1_next_date" placeholder="Enter Next Date" />
					<!-- <MonthYearPicker  v-model="imo1ForAdd.next_date" :min="new Date()" :max="new Date(2040, 12, 31)" returnmode="String" class="form-select"/> -->
				</div>
			</div>
			<div class="row mb-2 align-items-center g-2 g-md-0">
				<div class="col-md-2 col-6  text-md-end px-1">
					<label for="add_imo1_surveyor_id" class="form-label text-uppercase fw-bold m-0">Surveyor</label>
				</div>
				<div class="col-md-3 col-6 ">
					<multiselect v-model="imo1ForAdd.surveyor_id" :options="allSurveyorIdList" :custom-label="displayLabelSetting" placeholder="Select one" selectLabel="" deselectLabel=""></multiselect>
				</div>
				<div class="col-md-2 col-6  text-md-end px-1">
					<label for="add_imo1_country" class="form-label text-uppercase fw-bold m-0 me-3">Country</label><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
				</div>
				<div class="col-md-3 col-6 ">
					<input type="text" class="form-control" v-model="imo1ForAdd.country" id="add_imo1_country" placeholder="Enter Country" />
				</div>
			</div>
			<div class="row mb-2 align-items-center g-2 g-md-0">
				<div class="col-md-2 col-6  text-md-end px-1">
					<label for="add_imo1_hazard_class" class="form-label text-uppercase fw-bold m-0 me-3">Hazard Class</label
					><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
				</div>
				<div class="col-md-3 col-6 ">
					<input type="text" class="form-control" v-model="imo1ForAdd.hazard_class" id="add_imo1_hazard_class" placeholder="Enter Hazard Class" />
				</div>
				<div class="col-md-2 col-6  text-md-end px-1">
					<label for="add_imo1_inspection_location_id" class="form-label text-uppercase fw-bold m-0">Inspection Location</label>
				</div>
				<div class="col-md-3 col-6 ">
					<multiselect v-model="imo1ForAdd.inspection_location_id" :options="allInspectionLocationIdList" :custom-label="displayLabelSetting" placeholder="Select one" selectLabel="" deselectLabel=""></multiselect>
				</div>
			</div>
			<div class="row mb-2 align-items-center g-2 g-md-0">
				<div class="col-md-2 col-6  text-md-end px-1">
					<label for="add_imo1_customer_id" class="form-label text-uppercase fw-bold m-0">Customer</label>
				</div>
				<div class="col-md-3 col-6 ">
					<multiselect v-model="imo1ForAdd.customer_id" :options="allCustomerIdList" :custom-label="displayLabelSetting" placeholder="Select one" selectLabel="" deselectLabel=""></multiselect>
				</div>
				<div class="col-md-2 col-6  text-md-end px-1">
					<label for="add_imo1_cha_client" class="form-label text-uppercase fw-bold m-0">CHA Client</label>
				</div>
				<div class="col-md-3 col-6 ">
					<select class="form-select" v-model="imo1ForAdd.cha_client" id="add_cha_client">
						<optgroup v-if="allChaClientList" label="Choose CHA Client">
							<template v-for="chaClient in allChaClientList" :key="chaClient.id">
								<option :value="chaClient.id">{{ chaClient.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
			</div>
			<div class="row mb-4 align-items-center">
				<div class="col-md-2 col-6  text-md-end px-1">
					<label for="add_ivmo1_imo1_status" class="form-label text-uppercase fw-bold m-0">Status</label>
				</div>
				<div class="col-md-3 col-6 ">
					<select class="form-select" v-model="imo1ForAdd.imo1_status" id="add_imo1_status">
						<optgroup v-if="allImo1StatusList" label="Choose Status">
							<template v-for="imo1Status in allImo1StatusList" :key="imo1Status.id">
								<option :value="imo1Status.id">{{ imo1Status.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<!-- <div class="col-4">
					<label for="add_imo1_last_inspection_date" class="form-label text-uppercase fw-bold m-0 me-3">Last Inspection Date</label>
					<div>
						<input type="date" class="form-control" v-model="imo1ForAdd.last_inspection_date" id="add_imo1_last_inspection_date" placeholder="Enter Last Inspection Date" />
					</div>
				</div> -->
			</div>
			<!-- Walkway image -->
			<div class="row mb-4">
				<div class="col-md-2 col-12  text-md-end px-1">
					<label for="add_company_name" class="form-label text-uppercase fw-bold me-3">Upload Walkway Image</label>
				</div>
				<div class="col-md-7">
					<div class="d-flex flex-row gap-3">
						<!-- <template v-if="imo1ForAdd.id && imo1ForAdd.id > 0">
						</template> -->
						<div class="mb-2" v-if="imo1ForAdd.walkway_image && imo1ForAdd.walkway_image.length > 5">
							<img :src="docRoot+'/imo1/view-file/' + imo1ForAdd.id +'/'+imageId" style="max-width: 200px" />
							<p class="my-2 p-0"><a href="javascript:void(0)" class="text-danger" @click="clearImage()">Clear image</a></p>
						</div>
						<div v-else>
							<input type="file" id="header_url" ref="header_url" @change="prepareUpload($event)" accept="image/*" />
							<div class="d-flex flex-row gap-3 align-items-center mb-2">
								<label for="header_url" class="bg-dark p-2 text-white rounded-2">
									<span v-if="document.file_name">Upload new image</span>
									<span v-else>Upload image</span>
								</label>
								<button typ="button" class="btn btn-outline-danger" v-if="document.contents && document.contents.length > 0" @click="cancelUpload()">Clear</button>
							</div>
							<p class="text-dark mb-0"><small>Maximum upload size is 2MB. Supported format is JPG, JPEG and PNG only.</small></p>
							<p class="text-dark mb-0"><small>Please ensure that the dimensions are correct.</small></p>
						</div>
					</div>
				</div>
				<div class="col-md-3 col-6 " v-if="document.contents && document.contents.length > 0">
					<img :src="document.contents" class="img-fluid">
				</div>
			</div>
			<!-- Walkway image -->
			<div class="row mb-4">
				<div class="col-sm-4">
					<div class="clear text-center mb-2 fw-bold text-primary">ANY VISIBLE DAMAGE TO CLADDING/DECALS</div>
					<div class="row mb-2">
						<div class="col-5">&nbsp;</div>
						<div class="col-3 px-1 text-center fw-bold">CLADDING</div>
						<div class="col-3 px-1 text-center fw-bold">DECALS</div>
					</div>
					<div class="row mb-2 align-items-center">
						<div class="col-5">
							<label for="add_imo1_front_panel_cladding" class="form-label text-uppercase fw-bold m-0 me-3">Front Panel</label>
						</div>
						<div class="col-3 px-1">
							<select class="form-select" v-model="imo1ForAdd.front_panel_cladding" id="add_front_panel_cladding">
								<optgroup v-if="allFrontPanelCladdingList" label="Choose Front Panel Cladding">
									<template v-for="frontPanelCladding in allFrontPanelCladdingList" :key="frontPanelCladding.id">
										<option :value="frontPanelCladding.id">{{ frontPanelCladding.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
						<div class="col-3 px-1">
							<select class="form-select" v-model="imo1ForAdd.front_panel_decals" id="add_front_panel_decals">
								<optgroup v-if="allFrontPanelDecalsList" label="Choose Front Panel Decals">
									<template v-for="frontPanelDecals in allFrontPanelDecalsList" :key="frontPanelDecals.id">
										<option :value="frontPanelDecals.id">{{ frontPanelDecals.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-2 align-items-center">
						<div class="col-5">
							<label for="add_imo1_rear_panel_cladding" class="form-label text-uppercase fw-bold m-0 me-3">Rear Panel</label>
						</div>
						<div class="col-3 px-1">
							<select class="form-select" v-model="imo1ForAdd.rear_panel_cladding" id="add_rear_panel_cladding">
								<optgroup v-if="allRearPanelCladdingList" label="Choose Rear Panel Cladding">
									<template v-for="rearPanelCladding in allRearPanelCladdingList" :key="rearPanelCladding.id">
										<option :value="rearPanelCladding.id">{{ rearPanelCladding.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
						<div class="col-3 px-1">
							<select class="form-select" v-model="imo1ForAdd.rear_panel_decals" id="add_rear_panel_decals">
								<optgroup v-if="allRearPanelDecalsList" label="Choose Rear Panel Decals">
									<template v-for="rearPanelDecals in allRearPanelDecalsList" :key="rearPanelDecals.id">
										<option :value="rearPanelDecals.id">{{ rearPanelDecals.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-2 align-items-center">
						<div class="col-5">
							<label for="add_imo1_right_side_cladding" class="form-label text-uppercase fw-bold m-0 me-3">Right Side</label>
						</div>
						<div class="col-3 px-1">
							<select class="form-select" v-model="imo1ForAdd.right_side_cladding" id="add_right_side_cladding">
								<optgroup v-if="allRightSideCladdingList" label="Choose Right Side Cladding">
									<template v-for="rightSideCladding in allRightSideCladdingList" :key="rightSideCladding.id">
										<option :value="rightSideCladding.id">{{ rightSideCladding.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
						<div class="col-3 px-1">
							<select class="form-select" v-model="imo1ForAdd.right_side_decals" id="add_right_side_decals">
								<optgroup v-if="allRightSideDecalsList" label="Choose Right Side Decals">
									<template v-for="rightSideDecals in allRightSideDecalsList" :key="rightSideDecals.id">
										<option :value="rightSideDecals.id">{{ rightSideDecals.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-2 align-items-center">
						<div class="col-5">
							<label for="add_imo1_left_side_cladding" class="form-label text-uppercase fw-bold m-0 me-3">Left Side</label>
						</div>
						<div class="col-3 px-1">
							<select class="form-select" v-model="imo1ForAdd.left_side_cladding" id="add_left_side_cladding">
								<optgroup v-if="allLeftSideCladdingList" label="Choose Left Side Cladding">
									<template v-for="leftSideCladding in allLeftSideCladdingList" :key="leftSideCladding.id">
										<option :value="leftSideCladding.id">{{ leftSideCladding.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
						<div class="col-3 px-1">
							<select class="form-select" v-model="imo1ForAdd.left_side_decals" id="add_left_side_decals">
								<optgroup v-if="allLeftSideDecalsList" label="Choose Left Side Decals">
									<template v-for="leftSideDecals in allLeftSideDecalsList" :key="leftSideDecals.id">
										<option :value="leftSideDecals.id">{{ leftSideDecals.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-2 align-items-center">
						<div class="col-5">
							<label for="add_imo1_top_cladding" class="form-label text-uppercase fw-bold m-0 me-3">Top</label>
						</div>
						<div class="col-3 px-1">
							<select class="form-select" v-model="imo1ForAdd.top_cladding" id="add_top_cladding">
								<optgroup v-if="allTopCladdingList" label="Choose Top Cladding">
									<template v-for="topCladding in allTopCladdingList" :key="topCladding.id">
										<option :value="topCladding.id">{{ topCladding.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
						<div class="col-3 px-1">
							<select class="form-select" v-model="imo1ForAdd.top_decals" id="add_top_decals">
								<optgroup v-if="allTopDecalsList" label="Choose Top Decals">
									<template v-for="topDecals in allTopDecalsList" :key="topDecals.id">
										<option :value="topDecals.id">{{ topDecals.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-2 align-items-center">
						<div class="col-5">
							<label for="add_imo1_underside_cladding" class="form-label text-uppercase fw-bold m-0 me-3">Underside</label>
						</div>
						<div class="col-3 px-1">
							<select class="form-select" v-model="imo1ForAdd.underside_cladding" id="add_underside_cladding">
								<optgroup v-if="allUndersideCladdingList" label="Choose Underside Cladding">
									<template v-for="undersideCladding in allUndersideCladdingList" :key="undersideCladding.id">
										<option :value="undersideCladding.id">{{ undersideCladding.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
						<div class="col-3 px-1">
							<select class="form-select" v-model="imo1ForAdd.underside_decals" id="add_underside_decals">
								<optgroup v-if="allUndersideDecalsList" label="Choose Underside Decals">
									<template v-for="undersideDecals in allUndersideDecalsList" :key="undersideDecals.id">
										<option :value="undersideDecals.id">{{ undersideDecals.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
				</div>
				<div class="col-sm-4">
					<div class="clear text-center mb-2 fw-bold text-primary">ANY VISIBLE DAMAGE TO FRAME MEMBERS</div>
					<div class="row mb-2">
						<div class="col-8">&nbsp;</div>
						<div class="col-3 text-center fw-bold">YES/NO</div>
					</div>
					<div class="row mb-2 align-items-center">
						<div class="col-8">
							<label for="add_imo1_front_end_damage" class="form-label text-uppercase fw-bold m-0 me-3">Front End</label>
						</div>
						<div class="col-3 px-1">
							<select class="form-select" v-model="imo1ForAdd.front_end_damage" id="add_front_end_damage">
								<optgroup v-if="allFrontEndDamageList" label="Choose Front End Damage">
									<template v-for="frontEndDamage in allFrontEndDamageList" :key="frontEndDamage.id">
										<option :value="frontEndDamage.id">{{ frontEndDamage.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-2 align-items-center">
						<div class="col-8">
							<label for="add_imo1_rear_end_damage" class="form-label text-uppercase fw-bold m-0 me-3">Rear End</label>
						</div>
						<div class="col-3 px-1">
							<select class="form-select" v-model="imo1ForAdd.rear_end_damage" id="add_rear_end_damage">
								<optgroup v-if="allRearEndDamageList" label="Choose Rear End Damage">
									<template v-for="rearEndDamage in allRearEndDamageList" :key="rearEndDamage.id">
										<option :value="rearEndDamage.id">{{ rearEndDamage.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-2 align-items-center">
						<div class="col-8">
							<label for="add_imo1_right_side_damage" class="form-label text-uppercase fw-bold m-0 me-3">Right Side</label>
						</div>
						<div class="col-3 px-1">
							<select class="form-select" v-model="imo1ForAdd.right_side_damage" id="add_right_side_damage">
								<optgroup v-if="allRightSideDamageList" label="Choose Right Side Damage">
									<template v-for="rightSideDamage in allRightSideDamageList" :key="rightSideDamage.id">
										<option :value="rightSideDamage.id">{{ rightSideDamage.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-2 align-items-center">
						<div class="col-8">
							<label for="add_imo1_left_side_damage" class="form-label text-uppercase fw-bold m-0 me-3">Left Side</label>
						</div>
						<div class="col-3 px-1">
							<select class="form-select" v-model="imo1ForAdd.left_side_damage" id="add_left_side_damage">
								<optgroup v-if="allLeftSideDamageList" label="Choose Left Side Damage">
									<template v-for="leftSideDamage in allLeftSideDamageList" :key="leftSideDamage.id">
										<option :value="leftSideDamage.id">{{ leftSideDamage.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-2 align-items-center">
						<div class="col-8">
							<label for="add_imo1_top_damage" class="form-label text-uppercase fw-bold m-0 me-3">Top (Bent ABV 25MM)</label>
						</div>
						<div class="col-3 px-1">
							<select class="form-select" v-model="imo1ForAdd.top_damage" id="add_top_damage">
								<optgroup v-if="allTopDamageList" label="Choose Top (Bent ABV 25MM)">
									<template v-for="topDamage in allTopDamageList" :key="topDamage.id">
										<option :value="topDamage.id">{{ topDamage.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-2 align-items-center">
						<div class="col-8">
							<label for="add_imo1_underside_damage" class="form-label text-uppercase fw-bold m-0 me-3">Underside</label>
						</div>
						<div class="col-3 px-1">
							<select class="form-select" v-model="imo1ForAdd.underside_damage" id="add_underside_damage">
								<optgroup v-if="allUndersideDamageList" label="Choose Underside Damage">
									<template v-for="undersideDamage in allUndersideDamageList" :key="undersideDamage.id">
										<option :value="undersideDamage.id">{{ undersideDamage.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
				</div>
				<div class="col-sm-4">
					<div class="clear text-center mb-2 fw-bold text-primary">GENERAL APPEARANCE - INDICATE IF:</div>
					<div class="row mb-2 align-items-center">
						<div class="col-8">&nbsp;</div>
						<div class="col-3 px-1 text-center fw-bold">YES/NO</div>
					</div>
					<div class="row mb-2 align-items-center">
						<div class="col-8">
							<label for="add_imo1_exterior_wash_needed" class="form-label text-uppercase fw-bold m-0 me-3">Exterior Wash Needed</label>
						</div>
						<div class="col-3 px-1">
							<select class="form-select" v-model="imo1ForAdd.exterior_wash_needed" id="add_exterior_wash_needed">
								<optgroup v-if="allExteriorWashNeededList" label="Choose Exterior Wash Needed">
									<template v-for="exteriorWashNeeded in allExteriorWashNeededList" :key="exteriorWashNeeded.id">
										<option :value="exteriorWashNeeded.id">{{ exteriorWashNeeded.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-2 align-items-center">
						<div class="col-8">
							<label for="add_imo1_rusty_frame" class="form-label text-uppercase fw-bold m-0 me-3">Frame is Rusty</label>
						</div>
						<div class="col-3 px-1">
							<select class="form-select" v-model="imo1ForAdd.rusty_frame" id="add_rusty_frame">
								<optgroup v-if="allRustyFrameList" label="Choose Frame is Rusty">
									<template v-for="rustyFrame in allRustyFrameList" :key="rustyFrame.id">
										<option :value="rustyFrame.id">{{ rustyFrame.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-2 align-items-center">
						<div class="col-8">
							<label for="add_imo1_patchy_cladding" class="form-label text-uppercase fw-bold m-0 me-3">Cladding is Patchy</label>
						</div>
						<div class="col-3 px-1">
							<select class="form-select" v-model="imo1ForAdd.patchy_cladding" id="add_patchy_cladding">
								<optgroup v-if="allPatchyCladdingList" label="Choose Cladding is Patchy">
									<template v-for="patchyCladding in allPatchyCladdingList" :key="patchyCladding.id">
										<option :value="patchyCladding.id">{{ patchyCladding.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-2 align-items-center">
						<div class="col-8">
							<label for="add_imo1_product_spills" class="form-label text-uppercase fw-bold m-0 me-3">Product Spills (Stains)</label>
						</div>
						<div class="col-3 px-1">
							<select class="form-select" v-model="imo1ForAdd.product_spills" id="add_product_spills">
								<optgroup v-if="allProductSpillsList" label="Choose Product Spills (Stains)">
									<template v-for="productSpills in allProductSpillsList" :key="productSpills.id">
										<option :value="productSpills.id">{{ productSpills.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-2 align-items-center">
						<div class="col-8">
							<label for="add_imo1_renew_logo" class="form-label text-uppercase fw-bold m-0 me-3">Logo to Renew</label>
						</div>
						<div class="col-3 px-1">
							<select class="form-select" v-model="imo1ForAdd.renew_logo" id="add_renew_logo">
								<optgroup v-if="allRenewLogoList" label="Choose Logo to Renew">
									<template v-for="renewLogo in allRenewLogoList" :key="renewLogo.id">
										<option :value="renewLogo.id">{{ renewLogo.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-2 align-items-center">
						<div class="col-8">
							<label for="add_imo1_previous_haz" class="form-label text-uppercase fw-bold m-0 me-3">Previous Haz Labels</label>
						</div>
						<div class="col-3 px-1">
							<select class="form-select" v-model="imo1ForAdd.previous_haz" id="add_previous_haz">
								<optgroup v-if="allPreviousHazList" label="Choose Previous Haz Labels">
									<template v-for="previousHaz in allPreviousHazList" :key="previousHaz.id">
										<option :value="previousHaz.id">{{ previousHaz.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
				</div>
			</div>

			<div class="row mb-4">
				<div class="col-md-6">
					<div class="row mb-1">
						<div class="col-md-7 d-flex align-items-center">
							<div class="number">1.</div>
							<div class="flex-grow-1"><label for="add_imo1_ladder_nos" class="form-label fw-bold m-0 me-3">Ladder</label></div>
							<div>Nos:</div>
						</div>
						<div class="col-md-2 col-6">
							<input type="text" class="form-control" v-model="imo1ForAdd.ladder_nos" id="add_imo1_ladder_nos" />
						</div>
						<div class="col-md-3 col-6">
							<select class="form-select" v-model="imo1ForAdd.ladder_cond_status_id" id="add_ladder_cond_status_id">
								<optgroup v-if="allLadderCondStatusIdList" label="Choose Ladder Cond Status Id">
									<template v-for="ladderCondStatusId in allLadderCondStatusIdList" :key="ladderCondStatusId.id">
										<option :value="ladderCondStatusId.id">{{ ladderCondStatusId.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col-md-7 d-flex align-items-center">
							<div class="number">2.</div>
							<div class="flex-grow-1"><label for="add_imo1_document_box_nos" class="form-label fw-bold m-0 me-3">Document Box</label></div>
							<div>Nos:</div>
						</div>
						<div class="col-md-2 col-6">
							<input type="text" class="form-control" v-model="imo1ForAdd.document_box_nos" id="add_imo1_document_box_nos" />
						</div>
						<div class="col-md-3 col-6">
							<select class="form-select" v-model="imo1ForAdd.document_box_cond_status_id" id="add_document_box_cond_status_id">
								<optgroup v-if="allDocumentBoxCondStatusIdList" label="Choose Document Box Cond Status Id">
									<template v-for="documentBoxCondStatusId in allDocumentBoxCondStatusIdList" :key="documentBoxCondStatusId.id">
										<option :value="documentBoxCondStatusId.id">{{ documentBoxCondStatusId.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col-md-7 d-flex align-items-center">
							<div class="number">3.</div>
							<div class="flex-grow-1"><label for="add_imo1_temperature_gauge_nos" class="form-label fw-bold m-0 me-3">Temperature Gauge</label></div>
							<div>Nos:</div>
						</div>
						<div class="col-md-2 col-6">
							<input type="text" class="form-control" v-model="imo1ForAdd.temperature_gauge_nos" id="add_imo1_temperature_gauge_nos" />
						</div>
						<div class="col-md-3 col-6">
							<select class="form-select" v-model="imo1ForAdd.temperature_gauge_cond_status_id" id="add_temperature_gauge_cond_status_id">
								<optgroup v-if="allTemperatureGaugeCondStatusIdList" label="Choose Temperature Gauge Cond Status Id">
									<template v-for="temperatureGaugeCondStatusId in allTemperatureGaugeCondStatusIdList" :key="temperatureGaugeCondStatusId.id">
										<option :value="temperatureGaugeCondStatusId.id">{{ temperatureGaugeCondStatusId.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col-md-7 d-flex align-items-center">
							<div class="number">4.</div>
							<div class="flex-grow-1"><label for="add_imo1_steam_nos" class="form-label fw-bold m-0 me-3">Steam Pipe & Caps</label></div>
							<div>Nos:</div>
						</div>
						<div class="col-md-2 col-6">
							<input type="text" class="form-control" v-model="imo1ForAdd.steam_nos" id="add_imo1_steam_nos"/>
						</div>
						<div class="col-md-3 col-6">
							<select class="form-select" v-model="imo1ForAdd.steam_cond_status_id" id="add_steam_cond_status_id">
								<optgroup v-if="allSteamCondStatusIdList" label="Choose Steam Cond Status Id">
									<template v-for="steamCondStatusId in allSteamCondStatusIdList" :key="steamCondStatusId.id">
										<option :value="steamCondStatusId.id">{{ steamCondStatusId.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col-md-7 d-flex align-items-center">
							<div class="number">5.</div>
							<div class="flex-grow-1"><label for="add_imo1_steam_pressure_nos" class="form-label fw-bold m-0 me-3">Steam Pressure Relief Valve</label></div>
							<div>Nos:</div>
						</div>
						<div class="col-md-2 col-6">
							<input type="text" class="form-control" v-model="imo1ForAdd.steam_pressure_nos" id="add_imo1_steam_pressure_nos" />
						</div>
						<div class="col-md-3 col-6">
							<select class="form-select" v-model="imo1ForAdd.steam_pressure_cond_status_id" id="add_steam_pressure_cond_status_id">
								<optgroup v-if="allSteamPressureCondStatusIdList" label="Choose Steam Pressure Cond Status Id">
									<template v-for="steamPressureCondStatusId in allSteamPressureCondStatusIdList" :key="steamPressureCondStatusId.id">
										<option :value="steamPressureCondStatusId.id">{{ steamPressureCondStatusId.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col-md-7 d-flex align-items-center">
							<div class="number">6.</div>
							<div class="flex-grow-1"><label for="add_imo1_remote_system_nos" class="form-label fw-bold m-0 me-3">Remote Control System</label></div>
							<div>Nos:</div>
						</div>
						<div class="col-md-2 col-6">
							<input type="text" class="form-control" v-model="imo1ForAdd.remote_system_nos" id="add_imo1_remote_system_nos" />
						</div>
						<div class="col-md-3 col-6">
							<select class="form-select" v-model="imo1ForAdd.remote_system_cond_status_id" id="add_remote_system_cond_status_id">
								<optgroup v-if="allRemoteSystemCondStatusIdList" label="Choose Remote System Cond Status Id">
									<template v-for="remoteSystemCondStatusId in allRemoteSystemCondStatusIdList" :key="remoteSystemCondStatusId.id">
										<option :value="remoteSystemCondStatusId.id">{{ remoteSystemCondStatusId.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col-md-7 d-flex align-items-center">
							<div class="number">7.</div>
							<div class="flex-grow-1"><label for="add_imo1_electrical_heating_nos" class="form-label fw-bold m-0 me-3">Electrical Heating</label></div>
							<div>Nos:</div>
						</div>
						<div class="col-md-2 col-6">
							<input type="text" class="form-control" v-model="imo1ForAdd.electrical_heating_nos" id="add_imo1_electrical_heating_nos" />
						</div>
						<div class="col-md-3 col-6">
							<select class="form-select" v-model="imo1ForAdd.electrical_heating_cond_status_id" id="add_electrical_heating_cond_status_id">
								<optgroup v-if="allElectricalHeatingCondStatusIdList" label="Choose Electrical Heating Cond Status Id">
									<template v-for="electricalHeatingCondStatusId in allElectricalHeatingCondStatusIdList" :key="electricalHeatingCondStatusId.id">
										<option :value="electricalHeatingCondStatusId.id">{{ electricalHeatingCondStatusId.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col-md-7 d-flex align-items-center">
							<div class="number">8.</div>
							<div class="flex-grow-1"><label for="add_imo1_manlid_nos" class="form-label fw-bold m-0 me-3">Manlid</label></div>
							<div>Nos:</div>
						</div>
						<div class="col-md-2 col-6">
							<input type="number" class="form-control" v-model="imo1ForAdd.manlid_nos" id="add_imo1_manlid_nos" />
						</div>
						<div class="col-md-3 col-6">
							<select class="form-select" v-model="imo1ForAdd.manlid_cond_status_id" id="add_manlid_cond_status_id">
								<optgroup v-if="allManlidCondStatusIdList" label="Choose Manlid Cond Status Id">
									<template v-for="manlidCondStatusId in allManlidCondStatusIdList" :key="manlidCondStatusId.id">
										<option :value="manlidCondStatusId.id">{{ manlidCondStatusId.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col-md-7 d-flex align-items-center">
							<div class="number">8a.</div>
							<div class="flex-grow-1"><label for="add_imo1_manlid_swing_nos" class="form-label fw-bold m-0 me-3">Manlid Swing Bolts</label></div>
							<div>Nos:</div>
						</div>
						<div class="col-md-2 col-6">
							<input type="number" class="form-control" v-model="imo1ForAdd.manlid_swing_nos" id="add_imo1_manlid_swing_nos" />
						</div>
						<div class="col-md-3 col-6">
							<select class="form-select" v-model="imo1ForAdd.manlid_swing_cond_status_id" id="add_manlid_swing_cond_status_id">
								<optgroup v-if="allManlidSwingCondStatusIdList" label="Choose Manlid Swing Cond Status Id">
									<template v-for="manlidSwingCondStatusId in allManlidSwingCondStatusIdList" :key="manlidSwingCondStatusId.id">
										<option :value="manlidSwingCondStatusId.id">{{ manlidSwingCondStatusId.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col-md-7 d-flex align-items-center">
							<div class="number">9.</div>
							<div class="flex-grow-1"><label for="add_imo1_insp_hatch_nos" class="form-label fw-bold m-0 me-3">Inspection Hatch</label></div>
							<div>Nos:</div>
						</div>
						<div class="col-md-2 col-6">
							<input type="text" class="form-control" v-model="imo1ForAdd.insp_hatch_nos" id="add_imo1_insp_hatch_nos" />
						</div>
						<div class="col-md-3 col-6">
							<select class="form-select" v-model="imo1ForAdd.insp_hatch_cond_status_id" id="add_insp_hatch_cond_status_id">
								<optgroup v-if="allInspHatchCondStatusIdList" label="Choose Insp Hatch Cond Status Id">
									<template v-for="inspHatchCondStatusId in allInspHatchCondStatusIdList" :key="inspHatchCondStatusId.id">
										<option :value="inspHatchCondStatusId.id">{{ inspHatchCondStatusId.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col-md-7 d-flex align-items-center">
							<div class="number">9a.</div>
							<div class="flex-grow-1"><label for="add_imo1_insp_hatch_swing_bolt_no" class="form-label fw-bold m-0 me-3">Inspection Hatch Swing Bolts</label></div>
							<div>Nos:</div>
						</div>
						<div class="col-md-2 col-6">
							<input type="text" class="form-control" v-model="imo1ForAdd.insp_hatch_swing_bolt_no" id="add_imo1_insp_hatch_swing_bolt_no" />
						</div>
						<div class="col-md-3 col-6">
							<select class="form-select" v-model="imo1ForAdd.insp_hatch_swing_bolt_cond_status_id" id="add_insp_hatch_swing_bolt_cond_status_id">
								<optgroup v-if="allInspHatchSwingBoltCondStatusIdList" label="Choose Insp Hatch Swing Bolt Cond Status Id">
									<template v-for="inspHatchSwingBoltCondStatusId in allInspHatchSwingBoltCondStatusIdList" :key="inspHatchSwingBoltCondStatusId.id">
										<option :value="inspHatchSwingBoltCondStatusId.id">{{ inspHatchSwingBoltCondStatusId.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col-md-7 d-flex align-items-center">
							<div class="number">10.</div>
							<div class="flex-grow-1"><label for="add_imo1_spill_box_nos" class="form-label fw-bold m-0 me-3">Spill Box Covers</label></div>
							<div>Nos:</div>
						</div>
						<div class="col-md-2 col-6">
							<input type="text" class="form-control" v-model="imo1ForAdd.spill_box_nos" id="add_imo1_spill_box_nos" />
						</div>
						<div class="col-md-3 col-6">
							<select class="form-select" v-model="imo1ForAdd.spill_box_cond_status_id" id="add_spill_box_cond_status_id">
								<optgroup v-if="allSpillBoxCondStatusIdList" label="Choose Spill Box Cond Status Id">
									<template v-for="spillBoxCondStatusId in allSpillBoxCondStatusIdList" :key="spillBoxCondStatusId.id">
										<option :value="spillBoxCondStatusId.id">{{ spillBoxCondStatusId.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col-md-7 d-flex align-items-center">
							<div class="number">11.</div>
							<div class="flex-grow-1"><label for="add_imo1_pre_valve_nos" class="form-label fw-bold m-0 me-3">Pre/Vac Valves</label></div>
							<div>Nos:</div>
						</div>
						<div class="col-md-2 col-6">
							<input type="text" class="form-control" v-model="imo1ForAdd.pre_valve_nos" id="add_imo1_pre_valve_nos"/>
						</div>
						<div class="col-md-3 col-6">
							<select class="form-select" v-model="imo1ForAdd.pre_valve_cond_status_id" id="add_pre_valve_cond_status_id">
								<optgroup v-if="allPreValveCondStatusIdList" label="Choose Pre Valve Cond Status Id">
									<template v-for="preValveCondStatusId in allPreValveCondStatusIdList" :key="preValveCondStatusId.id">
										<option :value="preValveCondStatusId.id">{{ preValveCondStatusId.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col-md-7 d-flex align-items-center">
							<div class="number">12.</div>
							<div class="flex-grow-1"><label for="add_imo1_pre_bursting_disc_nos" class="form-label fw-bold m-0 me-3">Pre/Vac Bursting Disc</label></div>
							<div>Nos:</div>
						</div>
						<div class="col-md-2 col-6">
							<input type="text" class="form-control" v-model="imo1ForAdd.pre_bursting_disc_nos" id="add_imo1_pre_bursting_disc_nos"/>
						</div>
						<div class="col-md-3 col-6">
							<select class="form-select" v-model="imo1ForAdd.pre_bursting_disc_cond_status_id" id="add_pre_bursting_disc_cond_status_id">
								<optgroup v-if="allPreBurstingDiscCondStatusIdList" label="Choose Pre Bursting Disc Cond Status Id">
									<template v-for="preBurstingDiscCondStatusId in allPreBurstingDiscCondStatusIdList" :key="preBurstingDiscCondStatusId.id">
										<option :value="preBurstingDiscCondStatusId.id">{{ preBurstingDiscCondStatusId.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col-md-7 d-flex align-items-center">
							<div class="number">13.</div>
							<div class="flex-grow-1"><label for="add_imo1_walkyway_ls_nos" class="form-label fw-bold m-0 me-3">WalkyWay(Long Section)</label></div>
							<div>Nos:</div>
						</div>
						<div class="col-md-2 col-6">
							<input type="text" class="form-control" v-model="imo1ForAdd.walkyway_ls_nos" id="add_imo1_walkyway_ls_nos"/>
						</div>
						<div class="col-md-3 col-6">
							<select class="form-select" v-model="imo1ForAdd.walkyway_ls_cond_status_id" id="add_walkyway_ls_cond_status_id">
								<optgroup v-if="allWalkywayLsCondStatusIdList" label="Choose Walkyway Ls Cond Status Id">
									<template v-for="walkywayLsCondStatusId in allWalkywayLsCondStatusIdList" :key="walkywayLsCondStatusId.id">
										<option :value="walkywayLsCondStatusId.id">{{ walkywayLsCondStatusId.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col-md-7 d-flex align-items-center">
							<div class="number">14.</div>
							<div class="flex-grow-1"><label for="add_imo1_walkyway_scs_nos" class="form-label fw-bold m-0 me-3">WalkyWay(Short Cross Section)</label></div>
							<div>Nos:</div>
						</div>
						<div class="col-md-2 col-6">
							<input type="text" class="form-control" v-model="imo1ForAdd.walkyway_scs_nos" id="add_imo1_walkyway_scs_nos"/>
						</div>
						<div class="col-md-3 col-6">
							<select class="form-select" v-model="imo1ForAdd.walkyway_scs_cond_status_id" id="add_walkyway_scs_cond_status_id">
								<optgroup v-if="allWalkywayScsCondStatusIdList" label="Choose Walkyway Scs Cond Status Id">
									<template v-for="walkywayScsCondStatusId in allWalkywayScsCondStatusIdList" :key="walkywayScsCondStatusId.id">
										<option :value="walkywayScsCondStatusId.id">{{ walkywayScsCondStatusId.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col-md-7 d-flex align-items-center">
							<div class="number">14a.</div>
							<div class="flex-grow-1"><label for="add_imo1_walkyway_mls_nos" class="form-label fw-bold m-0 me-3">WalkyWay(Mid length Section)</label></div>
							<div>Nos:</div>
						</div>
						<div class="col-md-2 col-6">
							<input type="text" class="form-control" v-model="imo1ForAdd.walkyway_mls_nos" id="add_imo1_walkyway_mls_nos"/>
						</div>
						<div class="col-md-3 col-6">
							<select class="form-select" v-model="imo1ForAdd.walkyway_mls_cond_status_id" id="add_walkyway_mls_cond_status_id">
								<optgroup v-if="allWalkywayMlsCondStatusIdList" label="Choose Walkyway Mls Cond Status Id">
									<template v-for="walkywayMlsCondStatusId in allWalkywayMlsCondStatusIdList" :key="walkywayMlsCondStatusId.id">
										<option :value="walkywayMlsCondStatusId.id">{{ walkywayMlsCondStatusId.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
				</div>
				<div class="col-md-6">
					<div class="row mb-1">
						<div class="col-md-7 d-flex align-items-center">
							<div class="number">15.</div>
							<div class="flex-grow-1"><label for="add_imo1_airline_valve_nos" class="form-label fw-bold m-0 me-3">Airline Valve</label></div>
							<div>Nos:</div>
						</div>
						<div class="col-md-2 col-6">
							<input type="text" class="form-control" v-model="imo1ForAdd.airline_valve_nos" id="add_imo1_airline_valve_nos" />
						</div>
						<div class="col-md-3 col-6">
							<select class="form-select" v-model="imo1ForAdd.airline_valve_cond_status_id" id="add_airline_valve_cond_status_id">
								<optgroup v-if="allAirlineValveCondStatusIdList" label="Choose Airline Valve Cond Status Id">
									<template v-for="airlineValveCondStatusId in allAirlineValveCondStatusIdList" :key="airlineValveCondStatusId.id">
										<option :value="airlineValveCondStatusId.id">{{ airlineValveCondStatusId.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col-md-7 d-flex align-items-center">
							<div class="number">16.</div>
							<div class="flex-grow-1"><label for="add_imo1_tank_gauge_nos" class="form-label fw-bold m-0 me-3">Tank Pressure Gauge</label></div>
							<div>Nos:</div>
						</div>
						<div class="col-md-2 col-6">
							<input type="text" class="form-control" v-model="imo1ForAdd.tank_gauge_nos" id="add_imo1_tank_gauge_nos" />
						</div>
						<div class="col-md-3 col-6">
							<select class="form-select" v-model="imo1ForAdd.tank_gauge_cond_status_id" id="add_tank_gauge_cond_status_id">
								<optgroup v-if="allTankGaugeCondStatusIdList" label="Choose Tank Gauge Cond Status Id">
									<template v-for="tankGaugeCondStatusId in allTankGaugeCondStatusIdList" :key="tankGaugeCondStatusId.id">
										<option :value="tankGaugeCondStatusId.id">{{ tankGaugeCondStatusId.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col-md-7 d-flex align-items-center">
							<div class="number">17.</div>
							<div class="flex-grow-1"><label for="add_imo1_dipstick_nos" class="form-label fw-bold m-0 me-3">Dip-Stick</label></div>
							<div>Nos:</div>
						</div>
						<div class="col-md-2 col-6">
							<input type="text" class="form-control" v-model="imo1ForAdd.dipstick_nos" id="add_imo1_dipstick_nos"/>
						</div>
						<div class="col-md-3 col-6">
							<select class="form-select" v-model="imo1ForAdd.dipstick_cond_status_id" id="add_dipstick_cond_status_id">
								<optgroup v-if="allDipstickCondStatusIdList" label="Choose Dipstick Cond Status Id">
									<template v-for="dipstickCondStatusId in allDipstickCondStatusIdList" :key="dipstickCondStatusId.id">
										<option :value="dipstickCondStatusId.id">{{ dipstickCondStatusId.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col-md-7 d-flex align-items-center">
							<div class="number">18.</div>
							<div class="flex-grow-1"><label for="add_imo1_calibration_chart_nos" class="form-label fw-bold m-0 me-3">Calibration Chart</label></div>
							<div>Nos:</div>
						</div>
						<div class="col-md-2 col-6">
							<input type="text" class="form-control" v-model="imo1ForAdd.calibration_chart_nos" id="add_imo1_calibration_chart_nos" />
						</div>
						<div class="col-md-3 col-6">
							<select class="form-select" v-model="imo1ForAdd.calibration_chart_cond_status_id" id="add_calibration_chart_cond_status_id">
								<optgroup v-if="allCalibrationChartCondStatusIdList" label="Choose Calibration Chart Cond Status Id">
									<template v-for="calibrationChartCondStatusId in allCalibrationChartCondStatusIdList" :key="calibrationChartCondStatusId.id">
										<option :value="calibrationChartCondStatusId.id">{{ calibrationChartCondStatusId.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col-md-7 d-flex align-items-center">
							<div class="number">19.</div>
							<div class="flex-grow-1"><label for="add_imo1_syphon_pipe_nos" class="form-label fw-bold m-0 me-3">Syphon Pipe(Dip-Tube)Top Fill</label></div>
							<div>Nos:</div>
						</div>
						<div class="col-md-2 col-6">
							<input type="text" class="form-control" v-model="imo1ForAdd.syphon_pipe_nos" id="add_imo1_syphon_pipe_nos"/>
						</div>
						<div class="col-md-3 col-6">
							<select class="form-select" v-model="imo1ForAdd.syphon_pipe_cond_status_id" id="add_syphon_pipe_cond_status_id">
								<optgroup v-if="allSyphonPipeCondStatusIdList" label="Choose Syphon Pipe Cond Status Id">
									<template v-for="syphonPipeCondStatusId in allSyphonPipeCondStatusIdList" :key="syphonPipeCondStatusId.id">
										<option :value="syphonPipeCondStatusId.id">{{ syphonPipeCondStatusId.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col-md-7 d-flex align-items-center">
							<div class="number">20.</div>
							<div class="flex-grow-1"><label for="add_imo1_b_fly_valve_nos" class="form-label fw-bold m-0 me-3">B/FLY Valve (Clamp/Flange)</label></div>
							<div>Nos:</div>
						</div>
						<div class="col-md-2 col-6">
							<input type="text" class="form-control" v-model="imo1ForAdd.b_fly_valve_nos" id="add_imo1_b_fly_valve_nos"/>
						</div>
						<div class="col-md-3 col-6">
							<select class="form-select" v-model="imo1ForAdd.b_fly_valve_cond_status_id" id="add_b_fly_valve_cond_status_id">
								<optgroup v-if="allBFlyValveCondStatusIdList" label="Choose B Fly Valve Cond Status Id">
									<template v-for="bFlyValveCondStatusId in allBFlyValveCondStatusIdList" :key="bFlyValveCondStatusId.id">
										<option :value="bFlyValveCondStatusId.id">{{ bFlyValveCondStatusId.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col-md-7 d-flex align-items-center">
							<div class="number">21.</div>
							<div class="flex-grow-1"><label for="add_imo1_blank_flange_nos" class="form-label fw-bold m-0 me-3">Blank Flange, Top Fill (BOLTS) No.</label></div>
							<div>Nos:</div>
						</div>
						<div class="col-md-2 col-6">
							<input type="text" class="form-control" v-model="imo1ForAdd.blank_flange_nos" id="add_imo1_blank_flange_nos"/>
						</div>
						<div class="col-md-3 col-6">
							<select class="form-select" v-model="imo1ForAdd.blank_flange_cond_status_id" id="add_blank_flange_cond_status_id">
								<optgroup v-if="allBlankFlangeCondStatusIdList" label="Choose Blank Flange Cond Status Id">
									<template v-for="blankFlangeCondStatusId in allBlankFlangeCondStatusIdList" :key="blankFlangeCondStatusId.id">
										<option :value="blankFlangeCondStatusId.id">{{ blankFlangeCondStatusId.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col-md-7 d-flex align-items-center">
							<div class="number">22.</div>
							<div class="flex-grow-1"><label for="add_imo1_top_vapour_nos" class="form-label fw-bold m-0 me-3">Top Vapour B/Fly Valve (Clamp Flange)</label></div>
							<div>Nos:</div>
						</div>
						<div class="col-md-2 col-6">
							<input type="text" class="form-control" v-model="imo1ForAdd.top_vapour_nos" id="add_imo1_top_vapour_nos"/>
						</div>
						<div class="col-md-3 col-6">
							<select class="form-select" v-model="imo1ForAdd.top_vapour_cond_status_id" id="add_top_vapour_cond_status_id">
								<optgroup v-if="allTopVapourCondStatusIdList" label="Choose Top Vapour Cond Status Id">
									<template v-for="topVapourCondStatusId in allTopVapourCondStatusIdList" :key="topVapourCondStatusId.id">
										<option :value="topVapourCondStatusId.id">{{ topVapourCondStatusId.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col-md-7 d-flex align-items-center">
							<div class="number">23.</div>
							<div class="flex-grow-1"><label for="add_imo1_top_vapour_bolts_nos" class="form-label fw-bold m-0 me-3">Top Vapour Blank Flange (Bolts) No.</label></div>
							<div>Nos:</div>
						</div>
						<div class="col-md-2 col-6">
							<input type="text" class="form-control" v-model="imo1ForAdd.top_vapour_bolts_nos" id="add_imo1_top_vapour_bolts_nos"/>
						</div>
						<div class="col-md-3 col-6">
							<select class="form-select" v-model="imo1ForAdd.top_vapour_bolts_cond_status_id" id="add_top_vapour_bolts_cond_status_id">
								<optgroup v-if="allTopVapourBoltsCondStatusIdList" label="Choose Top Vapour Bolts Cond Status Id">
									<template v-for="topVapourBoltsCondStatusId in allTopVapourBoltsCondStatusIdList" :key="topVapourBoltsCondStatusId.id">
										<option :value="topVapourBoltsCondStatusId.id">{{ topVapourBoltsCondStatusId.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col-md-7 d-flex align-items-center">
							<div class="number">24.</div>
							<div class="flex-grow-1"><label for="add_imo1_flanged_provision_nos" class="form-label fw-bold m-0 me-3">Flanged Provision</label></div>
							<div>Nos:</div>
						</div>
						<div class="col-md-2 col-6">
							<input type="text" class="form-control" v-model="imo1ForAdd.flanged_provision_nos" id="add_imo1_flanged_provision_nos" />
						</div>
						<div class="col-md-3 col-6">
							<select class="form-select" v-model="imo1ForAdd.flanged_provision_cond_status_id" id="add_flanged_provision_cond_status_id">
								<optgroup v-if="allFlangedProvisionCondStatusIdList" label="Choose Flanged Provision Cond Status Id">
									<template v-for="flangedProvisionCondStatusId in allFlangedProvisionCondStatusIdList" :key="flangedProvisionCondStatusId.id">
										<option :value="flangedProvisionCondStatusId.id">{{ flangedProvisionCondStatusId.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col-md-7 d-flex align-items-center">
							<div class="number">25.</div>
							<div class="flex-grow-1"><label for="add_imo1_bottom_foot_nos" class="form-label fw-bold m-0 me-3">Bottom Foot Valve</label></div>
							<div>Nos:</div>
						</div>
						<div class="col-md-2 col-6">
							<input type="text" class="form-control" v-model="imo1ForAdd.bottom_foot_nos" id="add_imo1_bottom_foot_nos" />
						</div>
						<div class="col-md-3 col-6">
							<select class="form-select" v-model="imo1ForAdd.bottom_foot_cond_status_id" id="add_bottom_foot_cond_status_id">
								<optgroup v-if="allBottomFootCondStatusIdList" label="Choose Bottom Foot Cond Status Id">
									<template v-for="bottomFootCondStatusId in allBottomFootCondStatusIdList" :key="bottomFootCondStatusId.id">
										<option :value="bottomFootCondStatusId.id">{{ bottomFootCondStatusId.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col-md-7 d-flex align-items-center">
							<div class="number">26.</div>
							<div class="flex-grow-1"><label for="add_imo1_bottom_bfly_nos" class="form-label fw-bold m-0 me-3">Bottom B/Fly</label></div>
							<div>Nos:</div>
						</div>
						<div class="col-md-2 col-6">
							<input type="text" class="form-control" v-model="imo1ForAdd.bottom_bfly_nos" id="add_imo1_bottom_bfly_nos"/>
						</div>
						<div class="col-md-3 col-6">
							<select class="form-select" v-model="imo1ForAdd.bottom_bfly_cond_status_id" id="add_bottom_bfly_cond_status_id">
								<optgroup v-if="allBottomBflyCondStatusIdList" label="Choose Bottom Bfly Cond Status Id">
									<template v-for="bottomBflyCondStatusId in allBottomBflyCondStatusIdList" :key="bottomBflyCondStatusId.id">
										<option :value="bottomBflyCondStatusId.id">{{ bottomBflyCondStatusId.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col-md-7 d-flex align-items-center">
							<div class="number">27.</div>
							<div class="flex-grow-1"><label for="add_imo1_bottom_outlet_flange_nos" class="form-label fw-bold m-0 me-3">Bottom Outlet Flange</label></div>
							<div>Nos:</div>
						</div>
						<div class="col-md-2 col-6">
							<input type="text" class="form-control" v-model="imo1ForAdd.bottom_outlet_flange_nos" id="add_imo1_bottom_outlet_flange_nos" />
						</div>
						<div class="col-md-3 col-6">
							<select class="form-select" v-model="imo1ForAdd.bottom_outlet_flange_cond_status_id" id="add_bottom_outlet_flange_cond_status_id">
								<optgroup v-if="allBottomOutletFlangeCondStatusIdList" label="Choose Bottom Outlet Flange Cond Status Id">
									<template v-for="bottomOutletFlangeCondStatusId in allBottomOutletFlangeCondStatusIdList" :key="bottomOutletFlangeCondStatusId.id">
										<option :value="bottomOutletFlangeCondStatusId.id">{{ bottomOutletFlangeCondStatusId.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col-md-7 d-flex align-items-center">
							<div class="number">28.</div>
							<div class="flex-grow-1"><label for="add_imo1_bottom_valve_handle_nos" class="form-label fw-bold m-0 me-3">Bottom Valve Handle</label></div>
							<div>Nos:</div>
						</div>
						<div class="col-md-2 col-6">
							<input type="text" class="form-control" v-model="imo1ForAdd.bottom_valve_handle_nos" id="add_imo1_bottom_valve_handle_nos" />
						</div>
						<div class="col-md-3 col-6">
							<select class="form-select" v-model="imo1ForAdd.bottom_valve_handle_cond_status_id" id="add_bottom_valve_handle_cond_status_id">
								<optgroup v-if="allBottomValveHandleCondStatusIdList" label="Choose Bottom Valve Handle Cond Status Id">
									<template v-for="bottomValveHandleCondStatusId in allBottomValveHandleCondStatusIdList" :key="bottomValveHandleCondStatusId.id">
										<option :value="bottomValveHandleCondStatusId.id">{{ bottomValveHandleCondStatusId.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<!--  -->
					<div class="row mb-1">
						<div class="col-md-7 d-flex align-items-center">
							<div class="number">29.</div>
							<div class="flex-grow-1"><label for="add_imo1_bottom_bfly_ball_nos" class="form-label fw-bold m-0 me-3">Bottom B/Fly/Ball Valve Handle</label></div>
							<div>Nos:</div>
						</div>
						<div class="col-md-2 col-6">
							<input type="text" class="form-control" v-model="imo1ForAdd.bottom_bfly_ball_nos" id="add_imo1_bottom_bfly_ball_nos"/>
						</div>
						<div class="col-md-3 col-6">
							<select class="form-select" v-model="imo1ForAdd.bottom_bfly_ball_cond_status_id" id="add_bottom_bfly_ball_cond_status_id">
								<optgroup v-if="allBottomBflyBallCondStatusIdList" label="Choose Bottom Bfly Ball Cond Status Id">
									<template v-for="bottomBflyBallCondStatusId in allBottomBflyBallCondStatusIdList" :key="bottomBflyBallCondStatusId.id">
										<option :value="bottomBflyBallCondStatusId.id">{{ bottomBflyBallCondStatusId.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<!--  -->
					<div class="row mb-1">
						<div class="col-md-7 d-flex align-items-center">
							<div class="number">30.</div>
							<div class="flex-grow-1"><label for="add_imo1_fusible_link_no" class="form-label fw-bold m-0 me-3">Fusible Link</label></div>
							<div>Nos:</div>
						</div>
						<div class="col-md-2 col-6">
							<input type="text" class="form-control" v-model="imo1ForAdd.fusible_link_no" id="add_imo1_fusible_link_no" />
						</div>
						<div class="col-md-3 col-6">
							<select class="form-select" v-model="imo1ForAdd.fusible_link_cond_status_id" id="add_fusible_link_cond_status_id">
								<optgroup v-if="allFusibleLinkCondStatusIdList" label="Choose Fusible Link Cond Status Id">
									<template v-for="fusibleLinkCondStatusId in allFusibleLinkCondStatusIdList" :key="fusibleLinkCondStatusId.id">
										<option :value="fusibleLinkCondStatusId.id">{{ fusibleLinkCondStatusId.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<!--  -->
					<div class="row mb-1">
						<div class="col-7 d-flex align-items-center">
							<div class="number">31.</div>
							<div class="flex-grow-1"><label for="add_imo1_camera" class="form-label text-uppercase fw-bold m-0 me-3">Camera</label></div>
						</div>
						<div class="col-md-2 col-6 d-md-flex d-none align-items-center">&nbsp;</div>
						<div class="col-md-3 col-4 d-flex align-items-center">
							<select class="form-select" v-model="imo1ForAdd.camera" id="add_camera">
								<optgroup v-if="allCameraList" label="Choose Camera">
									<template v-for="camera in allCameraList" :key="camera.id">
										<option :value="camera.id">{{ camera.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
					<!--  -->
					<div class="row mb-1">
						<div class="col-7 d-flex align-items-center">
							<div class="number">32.</div>
							<div class="flex-grow-1"><label for="add_imo1_camera" class="form-label text-uppercase fw-bold m-0 me-3">GPS</label></div>
						</div>
						<div class="col-md-2 col-6 d-md-flex d-none align-items-center">&nbsp;</div>
						<div class="col-md-3 col-4 d-flex align-items-center">
							<select class="form-select" v-model="imo1ForAdd.gps" id="add_gps">
								<optgroup v-if="allGpsList" label="Choose GPS">
									<template v-for="gps in allGpsList" :key="gps.id">
										<option :value="gps.id">{{ gps.title }}</option>
									</template>
								</optgroup>
							</select>
						</div>
					</div>
				<!--  -->
				</div>
			</div>
			<!--  -->
			<div class="row mb-4 g-2">
				<div class="col-md-3 col-6">
					<label for="add_imo1_last_test_date" class="form-label text-uppercase fw-bold m-0 me-3">Last Test Date</label>
					<div>
						<input type="text" class="form-control" v-model="imo1ForAdd.last_test_date" id="add_imo1_last_test_date" placeholder="Enter Last Test Date" />
						<!-- <MonthYearPicker  v-model="imo1ForAdd.last_test_date" :min="new Date(1990, 1, 1)" :max="new Date()" returnmode="String" class="form-select"/> -->
					</div>
				</div>
				<div class="col-md-3 col-6">
					<label for="add_imo1_tare_wt" class="form-label text-uppercase fw-bold m-0 me-3">Tare Weight</label>
					<div>
						<input type="number" class="form-control" v-empty-zero v-model="imo1ForAdd.tare_wt" id="add_imo1_tare_wt" placeholder="Enter Tare Weight" />
					</div>
				</div>
				<div class="col-md-3 col-6">
					<label for="add_imo1_capacity" class="form-label text-uppercase fw-bold m-0 me-3">Capacity</label>
					<div>
						<input type="number" class="form-control" v-empty-zero v-model="imo1ForAdd.capacity" id="add_imo1_capacity" placeholder="Enter Capacity" />
					</div>
				</div>
				<div class="col-md-3 col-6">
					<label for="add_imo1_mgw" class="form-label text-uppercase fw-bold m-0 me-3">MGW</label>
					<div>
						<input type="number" class="form-control" v-empty-zero v-model="imo1ForAdd.mgw" id="add_imo1_mgw" placeholder="Enter MGW" />
					</div>
				</div>
			</div>
			<div class="row mb-4">
				<div class="col-md-6">
					<label for="add_imo1_comments" class="form-label text-uppercase fw-bold m-0 me-3">Comments</label><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
					<div>
						<textarea class="form-control" v-model="imo1ForAdd.comments" id="add_imo1_comments" placeholder="Enter Comments" rows="3"></textarea>
					</div>
				</div>
			</div>
		</template>
		<div class="row mb-5">
			<div class="col-md-3">
				<button type="button" class="btn btn-dark btn-sm w-100" v-if="tankNoVerified" @click="saveImo1()">SAVE CHANGES</button>
			</div>
		</div>
	</div>
</template>
<script>
	import {useVuelidate} from "@vuelidate/core";
	import {required, minValue, alphaNum, numeric, email, requiredIf, minLength} from "@vuelidate/validators";
	import * as bootstrap from "bootstrap";
	function initialState() {
		return {
			id: 0,
			ref_no: "",
			company_id: null,
			inspection_date: "",
			csc: "",
			loaded_at: "",
			tank_type_id: null,
			tank_no: "",
			tcode_id: 0,
			last_cargo_carried: "",
			mfgt_date: null,
			empty_clean: 1,
			empty_dirty: 1,
			cfs: null,
			for_client: null,
			loaded: 1,
			next_date: "",
			surveyor_id: null,
			country: "",
			hazard_class: "",
			inspection_location_id: null,
			customer_id: null,
			cha_client: 0,
			imo1_status: 1,
			walkway_image: null,
			last_inspection_date: "",
			front_panel_cladding: 0,
			front_panel_decals: 0,
			rear_panel_cladding: 0,
			rear_panel_decals: 0,
			right_side_cladding: 0,
			right_side_decals: 0,
			left_side_cladding: 0,
			left_side_decals: 0,
			top_cladding: 0,
			top_decals: 0,
			underside_cladding: 0,
			underside_decals: 0,
			front_end_damage: 0,
			rear_end_damage: 0,
			right_side_damage: 0,
			left_side_damage: 0,
			top_damage: 0,
			underside_damage: 0,
			exterior_wash_needed: 0,
			rusty_frame: 0,
			patchy_cladding: 0,
			product_spills: 0,
			renew_logo: 0,
			previous_haz: 0,
			ladder_nos: "",
			ladder_cond_status_id: 1,
			document_box_nos: "",
			document_box_cond_status_id: 1,
			temperature_gauge_nos: "",
			temperature_gauge_cond_status_id: 1,
			steam_nos: "",
			steam_cond_status_id: 1,
			steam_pressure_nos: "",
			steam_pressure_cond_status_id: 1,
			remote_system_nos: "",
			remote_system_cond_status_id: 1,
			electrical_heating_nos: "",
			electrical_heating_cond_status_id: 1,
			manlid_nos: "",
			manlid_cond_status_id: 1,
			manlid_swing_nos: "",
			manlid_swing_cond_status_id: 1,
			insp_hatch_nos: "",
			insp_hatch_cond_status_id: 1,
			insp_hatch_swing_bolt_no: "",
			insp_hatch_swing_bolt_cond_status_id: 1,
			spill_box_nos: "",
			spill_box_cond_status_id: 1,
			pre_valve_nos: "",
			pre_valve_cond_status_id: 1,
			pre_bursting_disc_nos: "",
			pre_bursting_disc_cond_status_id: 1,
			walkyway_ls_nos: "",
			walkyway_ls_cond_status_id: 1,
			walkyway_scs_nos: "",
			walkyway_scs_cond_status_id: 1,
			walkyway_mls_nos: "",
			walkyway_mls_cond_status_id: 1,
			airline_valve_nos: "",
			airline_valve_cond_status_id: 1,
			tank_gauge_nos: "",
			tank_gauge_cond_status_id: 1,
			dipstick_nos: "",
			dipstick_cond_status_id: 1,
			calibration_chart_nos: "",
			calibration_chart_cond_status_id: 1,
			syphon_pipe_nos: "",
			syphon_pipe_cond_status_id: 1,
			b_fly_valve_nos: "",
			b_fly_valve_cond_status_id: 1,
			blank_flange_nos: "",
			blank_flange_cond_status_id: 1,
			top_vapour_nos: "",
			top_vapour_cond_status_id: 1,
			top_vapour_bolts_nos: "",
			top_vapour_bolts_cond_status_id: 1,
			flanged_provision_nos: "",
			flanged_provision_cond_status_id: 1,
			bottom_foot_nos: "",
			bottom_foot_cond_status_id: 1,
			bottom_bfly_nos: "",
			bottom_bfly_cond_status_id: 1,
			bottom_outlet_flange_nos: "",
			bottom_outlet_flange_cond_status_id: 1,
			bottom_valve_handle_nos: "",
			bottom_valve_handle_cond_status_id: 1,
			bottom_bfly_ball_nos: "",
			bottom_bfly_ball_cond_status_id: 1,
			fusible_link_no: "",
			fusible_link_cond_status_id: 1,
			camera: 1,
			gps: 1,
			last_test_date: "",
			tare_wt: 0,
			capacity: 0,
			mgw: 0,
			comments: "",
			action: "",
		};
	}
	function initialStateValidations() {
		return {
			ref_no: {minLengthValue: minLength(1)},
			company_id: {required},
			csc: {minLengthValue: minLength(1)},
			loaded_at: {minLengthValue: minLength(1)},
			tank_no: {required, minLengthValue: minLength(1)},
			last_cargo_carried: {minLengthValue: minLength(1)},
			country: {minLengthValue: minLength(1)},
			hazard_class: {minLengthValue: minLength(1)},
			ladder_nos: {minLengthValue: minLength(1)},
			tare_wt: {numeric, minValue: minValue(0)},
			capacity: {numeric, minValue: minValue(0)},
			mgw: {numeric, minValue: minValue(0)},
			comments: {minLengthValue: minLength(1)}
		};
	}
	export default {
		name: "AddEditIMO1master",
		props: ["current_user_id", "all_permissions", "id", "param1"],
		setup() {
			return {
				v$: useVuelidate()
			};
		},
		data() {
			return {
				currentUser: siteUserObject,
				imo1ForAdd: initialState(),
				document: {
					uploaded_file: null,
					contents: null,
					upload_state: 0,
					upload_progress: 0,
					file_name: ""
				},
				tankNoVerified: false,
				lastThree: [],
				allCompanyIdList: [],
				allTankIdList: [],
				allTcodeIdList: [],
				allEmptyCleanList: [],
				allEmptyDirtyList: [],
				allCfsList: [],
				allForClientList: [],
				allLoadedList: [],
				allSurveyorIdList: [],
				allInspectionLocationIdList: [],
				allCustomerIdList: [],
				allChaClientList: [],
				allImo1StatusList: [],
				allFrontPanelCladdingList: [],
				allFrontPanelDecalsList: [],
				allRearPanelCladdingList: [],
				allRearPanelDecalsList: [],
				allRightSideCladdingList: [],
				allRightSideDecalsList: [],
				allLeftSideCladdingList: [],
				allLeftSideDecalsList: [],
				allTopCladdingList: [],
				allTopDecalsList: [],
				allUndersideCladdingList: [],
				allUndersideDecalsList: [],
				allFrontEndDamageList: [],
				allRearEndDamageList: [],
				allRightSideDamageList: [],
				allLeftSideDamageList: [],
				allTopDamageList: [],
				allUndersideDamageList: [],
				allExteriorWashNeededList: [],
				allRustyFrameList: [],
				allPatchyCladdingList: [],
				allProductSpillsList: [],
				allRenewLogoList: [],
				allPreviousHazList: [],
				allLadderCondStatusIdList: [],
				allDocumentBoxCondStatusIdList: [],
				allTemperatureGaugeCondStatusIdList: [],
				allSteamCondStatusIdList: [],
				allSteamPressureCondStatusIdList: [],
				allRemoteSystemCondStatusIdList: [],
				allElectricalHeatingCondStatusIdList: [],
				allManlidCondStatusIdList: [],
				allManlidSwingCondStatusIdList: [],
				allInspHatchCondStatusIdList: [],
				allInspHatchSwingBoltCondStatusIdList: [],
				allSpillBoxCondStatusIdList: [],
				allPreValveCondStatusIdList: [],
				allPreBurstingDiscCondStatusIdList: [],
				allWalkywayLsCondStatusIdList: [],
				allWalkywayScsCondStatusIdList: [],
				allWalkywayMlsCondStatusIdList: [],
				allAirlineValveCondStatusIdList: [],
				allTankGaugeCondStatusIdList: [],
				allDipstickCondStatusIdList: [],
				allCalibrationChartCondStatusIdList: [],
				allSyphonPipeCondStatusIdList: [],
				allBFlyValveCondStatusIdList: [],
				allBlankFlangeCondStatusIdList: [],
				allTopVapourCondStatusIdList: [],
				allTopVapourBoltsCondStatusIdList: [],
				allFlangedProvisionCondStatusIdList: [],
				allBottomFootCondStatusIdList: [],
				allBottomBflyCondStatusIdList: [],
				allBottomOutletFlangeCondStatusIdList: [],
				allBottomValveHandleCondStatusIdList: [],
				allBottomBflyBallCondStatusIdList: [],
				allFusibleLinkCondStatusIdList: [],
				allCameraList: [],
				allGpsList: []
			};
		},
		validations() {
			return {
				imo1ForAdd: initialStateValidations()
			};
		},
		methods: {
			cancelAddEdit(event) {
				this.imo1ForAdd = initialState();
				this.v$.$reset();
			},
			verifyTankNumber() {
				var that = this;
				this.showLoading("Verifying ...");
				axios
					.post(this.docRoot + "/imo1/verify-tank-number", { tankNo: this.imo1ForAdd.tank_no })
					.then(async function (response) {
						that.closeSwal();
						console.log(response);
						var status = response.data.status;
						if (status == 1){
							that.tankNoVerified = true;
							if (response.data.hasOwnProperty("lastthree") && response.data.lastthree.length > 0) {
								let arrLastThree = response.data.lastthree;
								that.lastThree = arrLastThree.filter((item, index) => arrLastThree.indexOf(item) === index);
							}
						}
						else {
							that.tankNoVerified = false;
							that.showErrors(response.data.message, "error", "bottom", 3000);
						}
					});
			},
			async loadAllMasters() {
				this.showLoading("Loading ...");
				this.allCompanyIdList = await this.loadAllCompany(true);
				this.allTankIdList = await this.loadAllTankType(true);
				this.allTcodeIdList = await this.loadAllTcode(true);
				this.allForClientList = await this.loadAllCustomer(true);
				this.allCustomerIdList = JSON.parse(JSON.stringify(this.allForClientList));
				this.allSurveyorIdList = await this.loadAllSurveyor(true);
				this.allInspectionLocationIdList = await this.loadAllInspectionLocation(true);
				this.allLadderCondStatusIdList = await this.loadAllImoConditionStatus(true);
				this.allDocumentBoxCondStatusIdList = JSON.parse(JSON.stringify(this.allLadderCondStatusIdList));
				this.allTemperatureGaugeCondStatusIdList = JSON.parse(JSON.stringify(this.allLadderCondStatusIdList));
				this.allSteamCondStatusIdList = JSON.parse(JSON.stringify(this.allLadderCondStatusIdList));
				this.allSteamPressureCondStatusIdList = JSON.parse(JSON.stringify(this.allLadderCondStatusIdList));
				this.allRemoteSystemCondStatusIdList = JSON.parse(JSON.stringify(this.allLadderCondStatusIdList));
				this.allElectricalHeatingCondStatusIdList = JSON.parse(JSON.stringify(this.allLadderCondStatusIdList));
				this.allManlidCondStatusIdList = JSON.parse(JSON.stringify(this.allLadderCondStatusIdList));
				this.allManlidSwingCondStatusIdList = JSON.parse(JSON.stringify(this.allLadderCondStatusIdList));
				this.allInspHatchCondStatusIdList = JSON.parse(JSON.stringify(this.allLadderCondStatusIdList));
				this.allInspHatchSwingBoltCondStatusIdList = JSON.parse(JSON.stringify(this.allLadderCondStatusIdList));
				this.allSpillBoxCondStatusIdList = JSON.parse(JSON.stringify(this.allLadderCondStatusIdList));
				this.allPreValveCondStatusIdList = JSON.parse(JSON.stringify(this.allLadderCondStatusIdList));
				this.allPreBurstingDiscCondStatusIdList = JSON.parse(JSON.stringify(this.allLadderCondStatusIdList));
				this.allWalkywayLsCondStatusIdList = JSON.parse(JSON.stringify(this.allLadderCondStatusIdList));
				this.allWalkywayScsCondStatusIdList = JSON.parse(JSON.stringify(this.allLadderCondStatusIdList));
				this.allWalkywayMlsCondStatusIdList = JSON.parse(JSON.stringify(this.allLadderCondStatusIdList));
				this.allAirlineValveCondStatusIdList = JSON.parse(JSON.stringify(this.allLadderCondStatusIdList));
				this.allTankGaugeCondStatusIdList = JSON.parse(JSON.stringify(this.allLadderCondStatusIdList));
				this.allDipstickCondStatusIdList = JSON.parse(JSON.stringify(this.allLadderCondStatusIdList));
				this.allCalibrationChartCondStatusIdList = JSON.parse(JSON.stringify(this.allLadderCondStatusIdList));
				this.allSyphonPipeCondStatusIdList = JSON.parse(JSON.stringify(this.allLadderCondStatusIdList));
				this.allBFlyValveCondStatusIdList = JSON.parse(JSON.stringify(this.allLadderCondStatusIdList));
				this.allBlankFlangeCondStatusIdList = JSON.parse(JSON.stringify(this.allLadderCondStatusIdList));
				this.allTopVapourCondStatusIdList = JSON.parse(JSON.stringify(this.allLadderCondStatusIdList));
				this.allTopVapourBoltsCondStatusIdList = JSON.parse(JSON.stringify(this.allLadderCondStatusIdList));
				this.allFlangedProvisionCondStatusIdList = JSON.parse(JSON.stringify(this.allLadderCondStatusIdList));
				this.allBottomFootCondStatusIdList = JSON.parse(JSON.stringify(this.allLadderCondStatusIdList));
				this.allBottomBflyCondStatusIdList = JSON.parse(JSON.stringify(this.allLadderCondStatusIdList));
				this.allBottomOutletFlangeCondStatusIdList = JSON.parse(JSON.stringify(this.allLadderCondStatusIdList));
				this.allBottomValveHandleCondStatusIdList = JSON.parse(JSON.stringify(this.allLadderCondStatusIdList));
				this.allBottomBflyBallCondStatusIdList = JSON.parse(JSON.stringify(this.allLadderCondStatusIdList));
				this.allFusibleLinkCondStatusIdList = JSON.parse(JSON.stringify(this.allLadderCondStatusIdList));
				this.closeSwal();
			},
			async saveImo1(event) {
				var that = this;
				const result = await this.v$.$validate();
				if (!result) {
					this.showToast("Form validation failed. Please check.", "error", "bottom", 2000);
					console.log(this.v$.$errors);
					return;
				}
				// Validate the inspection date
				if ( this.imo1ForAdd.inspection_date.length < 10) {
					this.showToast("Inspection date is required", "error", "bottom", 2000);
					return;
				}
				else {
					// validate date using regex
					var dateRegex = /^(0[1-9]|1[0-9]|2[0-9]|3[0-1])-(0[1-9]|1[0-2])-\d{4}$/;
					if (!dateRegex.test(this.imo1ForAdd.inspection_date)) {
						this.showToast("Invalid inspection date format", "error", "bottom", 2000);
						return;
					}
				}
				if ( this.imo1ForAdd.surveyor_id != 'null' && typeof this.imo1ForAdd.surveyor_id === 'object' && this.imo1ForAdd.surveyor_id.id) {
					this.imo1ForAdd.surveyor_id = this.imo1ForAdd.surveyor_id.id;
				}
				if ( this.imo1ForAdd.customer_id != 'null' && typeof this.imo1ForAdd.customer_id === 'object' && this.imo1ForAdd.customer_id.id) {
					this.imo1ForAdd.customer_id = this.imo1ForAdd.customer_id.id;
				}
				if ( this.imo1ForAdd.for_client != 'null' && typeof this.imo1ForAdd.for_client === 'object' && this.imo1ForAdd.for_client.id) {
					this.imo1ForAdd.for_client = this.imo1ForAdd.for_client.id;
				}
				if ( this.imo1ForAdd.inspection_location_id != 'null' && typeof this.imo1ForAdd.inspection_location_id === 'object' && this.imo1ForAdd.inspection_location_id.id) {
					this.imo1ForAdd.inspection_location_id = this.imo1ForAdd.inspection_location_id.id;
				}
				console.log(this.imo1ForAdd);
				
				// return;
				if (!this.imo1ForAdd.action || this.imo1ForAdd.action == "") this.imo1ForAdd.action = "details";
				this.imo1ForAdd.created_by = this.current_user_id;
				this.showLoading("Saving ...");
				axios
					.post(this.docRoot + "/imo1/save", {imo1: this.imo1ForAdd})
					.then(async function (response) {
						that.closeSwal();
						var status = response.data.status;
						if (status == 1) {
							// Set the ID so that duplicate records will not be created
							that.imo1ForAdd.id = response.data.id;
							if (that.document.uploaded_file == null || that.document.uploaded_file == undefined) {
								that.showToast("IMO 1 Condition Record saved successfully", "success", "bottom", 3000);
								// mode check param1 mobileApp 
								// if mode is add, then reload the page
								if(that.param1 === "mobileapp") {
									window.location = that.docRoot+"/operation-successful";
									that.showLoading("Loading ...");
								}else{
									setTimeout(() => {
										window.location = that.docRoot + "/imo1/";
										that.showLoading("Loading ...");
									}, 1500);
								}
								// document.body.scrollTop = 0;
								// document.documentElement.scrollTop = 0;
								// that.reloadEverything();
							}
							else {
								// this means that the file has been uploaded
								// Try to handle the upload
								that.handleUpload(response.data.id);
							}
						}
						else
							that.showErrors("IMO 1 Condition Record could not be saved successfully", response.data.messages, "bottom", 3000);
					})
					.catch(function (error) {
						console.log(error);
						that.closeSwal();
						that.showToast("IMO 1 Condition Record could not be saved successfully", "error", "bottom", 3000);
					});
			},
			async prepareUpload(event) {
				let file = event.target.files[0];
				if (file.type != "image/jpg" && file.type != "image/jpeg" && file.type != "image/png") {
					this.showToast("You can only upload JPG, JPEG and PNG images", "error", "bottom", 3000);
					return;
				}
				if (file.size > 2 * 1024 * 1024) {
					try {
						this.showToast("Compressing image...", "info", "bottom", 2000);
						const originalSize = (file.size / 1024 / 1024).toFixed(2);
						file = await this.compressImage(file, 1);
						const compressedSize = (file.size / 1024 / 1024).toFixed(2);
						this.showToast(`Image compressed from ${originalSize}MB to ${compressedSize}MB`, "success", "bottom", 2000);
					} catch (error) {
						console.error("Compression error:", error);
						this.showToast("Failed to compress image", "error", "bottom", 3000);
						return;
					}
				}
				this.document.uploaded_file = file;
				this.document.upload_state = 0;
				this.document.upload_progress = 0;
				this.document.file_name = this.document.uploaded_file.name;
				const reader = new FileReader();
				reader.onload = ((e) => {
					this.document.contents = e.target.result;
				});
				reader.readAsDataURL(file);
			},
			cancelUpload() {
				this.document = {
					uploaded_file: null,
					contents: null,
					upload_state: 0,
					upload_progress: 0,
					file_name: ""
				};
			},
			handleUpload(id) {
				let that = this;
				const formData = new FormData();
				formData.append("imo1_id", id);
				formData.append("uploaded_file", this.document.uploaded_file);
				// Send the data
				let URL = this.docRoot + "/imo1/upload-file";
				axios
					.post(URL, formData, {
						headers: {
							"Content-Type": "multipart/form-data"
						},
						onUploadProgress: function (progressEvent) {
							that.document.upload_state = 1;
							that.document.upload_progress = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
						}
					})
					.then(function (response) {
						that.document.upload_state = 2;
						that.document.upload_progress = 100;
						console.log(response);
						var status = response.data.status;
						/*
						if ( uploadStatus == 1 ) {
								console.log("4");
								// Ajax to submit
								that.showToast("IMO 1 Condition Record saved successfully", "success", "bottom", 3000);
							}
							else {
								console.log("5");
								// upload failed - stay here
								that.showToast("1 IMO 1 Condition Record could not be saved successfully", "error", "bottom", 3000);
							}
						*/
						if (status == 1) {
							that.showToast("IMO 1 Condition Record saved successfully", "success", "bottom", 3000);
							that.imageId = Math.round(Math.random() * 100);
							setTimeout(() => {
								window.location = that.docRoot + "/imo1/";
								that.showLoading("Loading ...");
							}, 1500);
							// document.body.scrollTop = 0;
							// document.documentElement.scrollTop = 0;
							// that.reloadEverything();
						}
						else {
							that.showErrors("IMO 1 Condition Record has been saved but the File could not be uploaded successfully", response.data.messages, "bottom", 5000);
						}
						return status;
					})
					.catch(function (error) {
						that.document.upload_progress = 0;
						that.document.upload_state = -1;
						console.log(error);
						that.closeSwal();
						that.showToast("File could not be uploaded successfully", "error", "bottom", 3000);
						return -1;
					});
			},
			clearImage() {
				let that = this;
				let URL = this.docRoot + "/imo1/clear-file/" + this.imo1ForAdd.id + "/123";
				this.showConfirm("Do you really want to delete the file?", "Yes", "No").then((result) => {
					if (result.isConfirmed) {
						this.showLoading("Clearing file ...");
						axios
							.post(URL, {}, {
								headers: {
									"Content-Type": "multipart/form-data"
								}
							})
							.then(function (response) {
								that.closeSwal();
								var status = response.data.status;
								console.log(response);
								
								if (status == 1) {
									that.showToast("File cleared successfully", "success", "bottom", 3000);
									that.cancelUpload();
									that.imo1ForAdd.walkway_image = null;
								}
								else {
									that.showErrors("File could not be cleared successfully", response.data.messages, "bottom", 5000);
								}
								return status;
							})
							.catch(function (error) {
								console.log(error);
								that.closeSwal();
								that.showToast("File could not be cleared successfully", "error", "bottom", 3000);
								return -1;
							});
					}
				});
			},
			toggleImo1(imo1, status) {
				var that = this;
				Swal.fire({
					icon: "question",
					html: "Do you really want to " + (status == 1 ? "reactivate" : "deactivate") + " the IMO 1 Condition record?",
					showCancelButton: true
				}).then((result) => {
					if (result.isConfirmed) {
						that.imo1ForAdd = imo1;
						that.imo1ForAdd.status = status;
						that.imo1ForAdd.action = "status";
						that.saveImo1();
					}
				});
			},
			reloadEverything() {
				if (this.id !== undefined && !isNaN(this.id)) {
					this.mode = "edit";
					this.cancelUpload();
					// This is Edit mode - fetch inquiry data
					var that = this;
					this.tankNoVerified = false;
					var URL = this.docRoot + "/api/imo1/get-record/" + this.id;
					this.showLoading("Loading ...");
					axios
						.post(URL, {})
						.then(function (response) {
							that.closeSwal();
							that.imo1ForAdd = Object.assign({}, response.data);
						})
						.catch(function (error) {
							console.log(error);
						});
				}
			},
			displayLabelSetting ({id, text}) {
				return `${text}`;
			},
		},
		async mounted() {
			if (this.id > 0){
				this.reloadEverything();
				let duplicate = new URL(window.location.toString()).searchParams.get("duplicate");
				// if( duplicate == "1" )
					this.tankNoVerified = false;
				// else
				// 	this.tankNoVerified = true;
			}
			this.imageId = Math.round(Math.random() * 100);
			this.allEmptyCleanList = [
				{id: "1", title: "Yes"},
				{id: "0", title: "No"},
				{id: "-1", title: "NA"}
			];
			this.allEmptyDirtyList = [
				{id: "1", title: "Yes"},
				{id: "0", title: "No"},
				{id: "-1", title: "NA"}
			];
			this.allCfsList = [
				{id: "1", title: "In"},
				{id: "0", title: "Out"},
				{id: "-1", title: "NA"}
			];
			this.allLoadedList = [
				{id: "1", title: "Yes"},
				{id: "0", title: "No"},
				{id: "-1", title: "NA"}
			];
			this.allChaClientList = [
				{id: "1", title: "Yes"},
				{id: "0", title: "No"}
			];
			this.allImo1StatusList = [
				{id: "1", title: "Import"},
				{id: "0", title: "Export"}
			];
			this.allFrontPanelCladdingList = [
				{id: "1", title: "Yes"},
				{id: "0", title: "No"},
				{id: "-1", title: "NA"}
			];
			this.allFrontPanelDecalsList = [
				{id: "1", title: "Yes"},
				{id: "0", title: "No"},
				{id: "-1", title: "NA"}
			];
			this.allRearPanelCladdingList = [
				{id: "1", title: "Yes"},
				{id: "0", title: "No"},
				{id: "-1", title: "NA"}
			];
			this.allRearPanelDecalsList = [
				{id: "1", title: "Yes"},
				{id: "0", title: "No"},
				{id: "-1", title: "NA"}
			];
			this.allRightSideCladdingList = [
				{id: "1", title: "Yes"},
				{id: "0", title: "No"},
				{id: "-1", title: "NA"}
			];
			this.allRightSideDecalsList = [
				{id: "1", title: "Yes"},
				{id: "0", title: "No"},
				{id: "-1", title: "NA"}
			];
			this.allLeftSideCladdingList = [
				{id: "1", title: "Yes"},
				{id: "0", title: "No"},
				{id: "-1", title: "NA"}
			];
			this.allLeftSideDecalsList = [
				{id: "1", title: "Yes"},
				{id: "0", title: "No"},
				{id: "-1", title: "NA"}
			];
			this.allTopCladdingList = [
				{id: "1", title: "Yes"},
				{id: "0", title: "No"},
				{id: "-1", title: "NA"}
			];
			this.allTopDecalsList = [
				{id: "1", title: "Yes"},
				{id: "0", title: "No"},
				{id: "-1", title: "NA"}
			];
			this.allUndersideCladdingList = [
				{id: "1", title: "Yes"},
				{id: "0", title: "No"},
				{id: "-1", title: "NA"}
			];
			this.allUndersideDecalsList = [
				{id: "1", title: "Yes"},
				{id: "0", title: "No"},
				{id: "-1", title: "NA"}
			];
			this.allFrontEndDamageList = [
				{id: "1", title: "Yes"},
				{id: "0", title: "No"},
				{id: "-1", title: "NA"}
			];
			this.allRearEndDamageList = [
				{id: "1", title: "Yes"},
				{id: "0", title: "No"},
				{id: "-1", title: "NA"}
			];
			this.allRightSideDamageList = [
				{id: "1", title: "Yes"},
				{id: "0", title: "No"},
				{id: "-1", title: "NA"}
			];
			this.allLeftSideDamageList = [
				{id: "1", title: "Yes"},
				{id: "0", title: "No"},
				{id: "-1", title: "NA"}
			];
			this.allTopDamageList = [
				{id: "1", title: "Yes"},
				{id: "0", title: "No"},
				{id: "-1", title: "NA"}
			];
			this.allUndersideDamageList = [
				{id: "1", title: "Yes"},
				{id: "0", title: "No"},
				{id: "-1", title: "NA"}
			];
			this.allExteriorWashNeededList = [
				{id: "1", title: "Yes"},
				{id: "0", title: "No"},
				{id: "-1", title: "NA"}
			];
			this.allRustyFrameList = [
				{id: "1", title: "Yes"},
				{id: "0", title: "No"},
				{id: "-1", title: "NA"}
			];
			this.allPatchyCladdingList = [
				{id: "1", title: "Yes"},
				{id: "0", title: "No"},
				{id: "-1", title: "NA"}
			];
			this.allProductSpillsList = [
				{id: "1", title: "Yes"},
				{id: "0", title: "No"},
				{id: "-1", title: "NA"}
			];
			this.allRenewLogoList = [
				{id: "1", title: "Yes"},
				{id: "0", title: "No"},
				{id: "-1", title: "NA"}
			];
			this.allPreviousHazList = [
				{id: "1", title: "Yes"},
				{id: "0", title: "No"},
				{id: "-1", title: "NA"}
			];
			this.allCameraList = [
				{id: "1", title: "Yes"},
				{id: "0", title: "No"}
			];
			this.allGpsList = [
				{id: "1", title: "Yes"},
				{id: "0", title: "No"}
			];
			await this.loadAllMasters();
			// this.reloadEverything();
			let _allSurveyorIdList = this.allSurveyorIdList;
			if(Array.isArray(_allSurveyorIdList) && _allSurveyorIdList.length > 0){
				this.allSurveyorIdList = _allSurveyorIdList.map(x => {return { id: x.id, text: x.name }});
			}
			let _allCustomerIdList = this.allCustomerIdList;
			if(Array.isArray(_allCustomerIdList) && _allCustomerIdList.length > 0){
				this.allCustomerIdList = _allCustomerIdList.map(x => {return { id: x.id, text: x.name }});
			}
			let _allForClientList = this.allForClientList;
			if(Array.isArray(_allForClientList) && _allForClientList.length > 0){
				this.allForClientList = _allForClientList.map(x => {return { id: x.id, text: x.name }});
			}
			let _allInspectionLocationIdList = this.allInspectionLocationIdList;
			if(Array.isArray(_allInspectionLocationIdList) && _allInspectionLocationIdList.length > 0){
				this.allInspectionLocationIdList = _allInspectionLocationIdList.map(x => {return { id: x.id, text: x.name }});
			}
			if (this.imo1ForAdd.surveyor_id) {
				if (Array.isArray(this.allSurveyorIdList) && this.allSurveyorIdList.length > 0) {
					let _allRelationList = this.allSurveyorIdList;
					let relationId = parseInt(this.imo1ForAdd.surveyor_id);
					this.imo1ForAdd.surveyor_id = _allRelationList.find(item => item.id === relationId);
				}
			}
			if (this.imo1ForAdd.customer_id) {
				if (Array.isArray(this.allCustomerIdList) && this.allCustomerIdList.length > 0) {
					let _allRelationList = this.allCustomerIdList;
					let relationId = parseInt(this.imo1ForAdd.customer_id);
					this.imo1ForAdd.customer_id = _allRelationList.find(item => item.id === relationId);
				}
			}
			if (this.imo1ForAdd.for_client) {
				if (Array.isArray(this.allForClientList) && this.allForClientList.length > 0) {
					let _allRelationList = this.allForClientList;
					let relationId = parseInt(this.imo1ForAdd.for_client);
					this.imo1ForAdd.for_client = _allRelationList.find(item => item.id === relationId);
				}
			}
			if (this.imo1ForAdd.inspection_location_id) {
				if (Array.isArray(this.allInspectionLocationIdList) && this.allInspectionLocationIdList.length > 0) {
					let _allRelationList = this.allInspectionLocationIdList;
					let relationId = parseInt(this.imo1ForAdd.inspection_location_id);
					this.imo1ForAdd.inspection_location_id = _allRelationList.find(item => item.id === relationId);
				}
			}
		}
	};
</script>
<style>
.number{
	width: 35px;
}
</style>
